export default "__VITE_ASSET__Q$5PSUY6__"